module.exports = __webpack_public_path__ + "img/photo1.f86281fa.png";